import React from "react";
import { Input, Table } from 'antd';
import { getCurrentShopId } from "../shop/get-current-shop";
import usePagination from "../../components/pagination";
import SwitchShop from "../shop/switch-shop";
import dayjs from "dayjs";
import clipboard from "../../utils/clipboard";

const statusMap = {
    0 : '待审核',
    1: '审核中',
    2: '生效',
    3: '失效',
};

const versionMap = {
    1: '基础版',
    2: '专业版',
    3: '连锁版',
};

export default () => {
    const [joins, setJoins] = React.useState([]);
    const { pagination, setTotal } = usePagination({
        onChange: (page, pageSize) => {
            getJoinList(page, pageSize).then(res => {
                setJoins(res.rows);
                setTotal(res.count);
            });
        },
    });
    const columns = [
      {
        title: '名称',
        dataIndex: 'targetAcc',
        render: (acc) => {
          return <span>{acc.companyName || acc.realname}</span>;
        },
      },
      {
        title: '注册时间',
        dataIndex: 'targetAcc',
        render: (acc) => dayjs(acc.createTime).format('YYYY-MM-DD'),
      },
      {
        title: '版本',
        dataIndex: 'targetAcc',
        render: (acc) => versionMap[acc.versionId],
      },
      {
        title: '状态',
        dataIndex: 'targetAcc',
        render: (acc) => statusMap[acc.status],
      },
      {
        title: '邀请时间',
        dataIndex: 'createTime',
        render: (createTime) => dayjs(createTime).format('YYYY-MM-DD'),
      },
      {
        title: '邀请人',
        dataIndex: 'user',
        render: (user) => user.username,
      },
      {
        title: '操作',
        fixed: 'right',
        render: () => {
            return <a>佣金流水</a>
        },
      },
    ];

    React.useEffect(() => {
        getJoinList().then(res => {
            setJoins(res.rows);
            setTotal(res.count);
        });
    }, [])

    const getJoinList = async (page = 1, pageSize = 10) => { 
        const shopId = await getCurrentShopId();
        const response = await fetch(`/api/join/list?shopId=${shopId}&page=${page}&pageSize=${pageSize}`);
        const result = await response.json();

        if(result?.success) {
            return result.data;
        }else{
            return [];
        }
    }

    const getInviteUrl = async () => {
        const shopId = await getCurrentShopId();
        
        return `https://yxdj.tech/regist?shopId=${shopId}&userId=${window.__baseInfo.userId}`;
    }

    return (
        <div>
            <SwitchShop />
            <h2>邀请流程</h2>
            <ul style={{listStyle: 'none', padding: 0, margin: 0, display: 'flex', gap: '15px', whiteSpace: 'nowrap', flexWrap: 'wrap'}}>
                <li>
                  1、
                  <a onClick={async() => {
                    clipboard(await getInviteUrl(), '邀请链接已复制，发送给你的邀请对象即可。')
                  }}
                  >复制邀请链接(点击复制)</a>
                </li>
                <li>2、发送链接给邀请对象</li>
                <li>3、被邀请者注册</li>
                <li>4、邀请成功！</li>
            </ul>
            <h2>邀请列表(已入驻)</h2>
            <Table rowKey={'id'} columns={columns} dataSource={joins} pagination={pagination} scroll={{ x: 'max-content' }} />
        </div>
    )
}